<div class="flex gap-4 justify-between items-center">
    <div class="self-start">
      <img
        alt="drag-item"
        src="assets/shared-icons/neptune-icon-blue-drag-handle.svg"
      />
    </div>

    <input
      #textInput
      (input)="onInputChange(textInput.value)"
      [value]="value"
      maxlength="50"
      placeholder="Add {{ implicationType }}"
      class="px-4 py-2 border-solid border-1 border-neptune-border-subtle rounded-s"
    />
    <button type="button" (click)="clearSelection()">
      <img
        alt="clear-input"
        src="assets/shared-icons/neptune-icon-blue-close.svg"
      />
    </button>
  </div>
